import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal is-active"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1)
const _hoisted_3 = { class: "modal-card" }
const _hoisted_4 = { class: "modal-card-head" }
const _hoisted_5 = { class: "modal-card-title is-title-shrink" }
const _hoisted_6 = { class: "ml-2" }
const _hoisted_7 = { class: "filter-area" }
const _hoisted_8 = { class: "ml-2 mt-2" }
const _hoisted_9 = { class: "is-flex-direction-column is-align-items-center is-justify-content-space-between mb-2" }
const _hoisted_10 = { class: "mb-1" }
const _hoisted_11 = { class: "datepicker-export" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "xmx-icon-left" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "xmx-icon-right" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "mb-1 mt-3" }
const _hoisted_20 = { class: "recipient-filter is-flex is-flex-direction-row" }
const _hoisted_21 = { class: "recipient-filter-input" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3is-flex is-justify-content-space-evenly is-align-items-center" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "container is-fluid custom-heavy-line-separator" }, null, -1)
const _hoisted_24 = { class: "custom-card is-flex-direction-column is-align-items-center is-justify-content-space-between mb-4" }
const _hoisted_25 = {
  key: 0,
  class: "is-flex is-align-items-center is-justify-content-center"
}
const _hoisted_26 = {
  key: 2,
  class: "is-flex is-align-items-center is-justify-content-center"
}
const _hoisted_27 = { class: "modal-card-foot custom-modal-card-foot is-justify-content-end" }
const _hoisted_28 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_29 = ["title", "disabled"]
const _hoisted_30 = {
  key: 0,
  class: "icon"
}
const _hoisted_31 = {
  key: 1,
  class: "icon"
}
const _hoisted_32 = {
  key: 1,
  class: "ml-2"
}
const _hoisted_33 = ["title", "disabled"]
const _hoisted_34 = {
  key: 0,
  class: "icon"
}
const _hoisted_35 = {
  key: 1,
  class: "icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_model_list_select = _resolveComponent("model-list-select")!
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_TransactionItem = _resolveComponent("TransactionItem")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_ctx.$modal.modal.value == _ctx.$options.name)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("header", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$gettext("All transactions")), 1)
            ]),
            _createElementVNode("button", {
              class: "delete",
              "aria-label": "close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$modal.back()))
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$gettext("Select timespan:")), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_date_picker, {
                    value: _ctx.exportDate,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.exportDate) = $event)),
                    open: _ctx.datePickerShow ? true : null,
                    range: "",
                    "prefix-class": "xmx",
                    editable: false,
                    placeholder: _ctx.$gettext('All transactions'),
                    onClear: _cache[3] || (_cache[3] = 
                  () => {
                    _ctx.selectedTimeSpanType = ''
                    _ctx.datePickerShow = false
                  }
                ),
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.datePickerShow = _ctx.selectedTimeSpanType ? true : false)),
                    onPick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedTimeSpanType = '')),
                    "disabled-date": _ctx.disabledDates
                  }, {
                    header: _withCtx(({ emit }) => [
                      _createElementVNode("div", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectorsOrder, (selector) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass([{
                        selected: selector == _ctx.selectedTimeSpanType,
                      }, "timespan"])
                          }, [
                            _createElementVNode("button", {
                              class: "xmx-btn xmx-btn-text",
                              onClick: 
                          () => {
                            _ctx.selectedTimeSpanOffset =
                              _ctx.selectedTimeSpanType != selector
                                ? -1
                                : _ctx.selectedTimeSpanOffset - 1
                            _ctx.selectedTimeSpanType = selector
                            emit(_ctx.selectedTimeSpan)
                          }
                        
                            }, _hoisted_14, 8, _hoisted_12),
                            _createElementVNode("button", {
                              class: "xmx-btn xmx-btn-text",
                              onClick: 
                          () => {
                            _ctx.selectedTimeSpanType = selector
                            _ctx.selectedTimeSpanOffset = 0
                            emit(_ctx.selectedTimeSpan)
                          }
                        
                            }, _toDisplayString(_ctx.selectorLabels[selector]), 9, _hoisted_15),
                            _createElementVNode("button", {
                              class: _normalizeClass(["xmx-btn xmx-btn-text", {
                          hide:
                            _ctx.selectedTimeSpanType != selector ||
                            _ctx.isSelectionCurrent,
                        }]),
                              onClick: ($event: any) => {
                          ;[_ctx.selectedTimeSpanOffset++, emit(_ctx.selectedTimeSpan)]
                        }
                            }, _hoisted_18, 10, _hoisted_16),
                            _createElementVNode("button", {
                              class: _normalizeClass(["xmx-btn xmx-btn-text confirm", { hide: _ctx.selectedTimeSpanType != selector }]),
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.datePickerShow = false))
                            }, _toDisplayString(_ctx.$gettext("confirm")), 3)
                          ], 2))
                        }), 256))
                      ])
                    ]),
                    _: 1
                  }, 8, ["value", "open", "placeholder", "disabled-date"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$gettext("Select recipient:")), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_model_list_select, {
                      list: 
                    _ctx.recipientBatchLoader.elements.map((r, idx) => ({
                      name: r.name,
                      idx,
                    }))
                  ,
                      "option-value": "idx",
                      "option-text": "name",
                      modelValue: _ctx.selectedRecipientIdx,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedRecipientIdx) = $event)),
                      placeholder: _ctx.$gettext('All recipient'),
                      onSearchchange: _ctx.onRecipientSearch
                    }, null, 8, ["list", "modelValue", "placeholder", "onSearchchange"])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["recipient-filter-reset", { disable: _ctx.selectedRecipientIdx === null }]),
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectedRecipientIdx = null))
                    }, [
                      (_ctx.recipientBatchLoader.isNewBatchLoading)
                        ? (_openBlock(), _createBlock(_component_fa_icon, {
                            key: 0,
                            class: "refreshing",
                            icon: "sync"
                          }))
                        : (_ctx.selectedRecipientIdx !== null)
                          ? (_openBlock(), _createBlock(_component_fa_icon, {
                              key: 1,
                              icon: "fa-xmark"
                            }))
                          : (_openBlock(), _createBlock(_component_fa_icon, {
                              key: 2,
                              icon: "fa-user"
                            }))
                    ], 2)
                  ])
                ])
              ])
            ]),
            _hoisted_22,
            _hoisted_23
          ]),
          _createElementVNode("section", {
            class: "modal-card-body custom-card-transactions",
            ref: "transactionsContainer",
            onScroll: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.transactionBatchLoader.getNextElements && _ctx.transactionBatchLoader.getNextElements(...args)))
          }, [
            _createElementVNode("div", _hoisted_24, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactionBatchLoader.elements.value, (transaction) => {
                return (_openBlock(), _createBlock(_component_TransactionItem, {
                  key: transaction,
                  transaction: transaction,
                  onClick: ($event: any) => (
              _ctx.$modal.open('ConfirmPaymentModal', {
                transaction,
                type:
                  transaction.amount < 0 &&
                  _ctx.$modal.args.value[0].account.safeWalletRecipient?.name ===
                    transaction.related
                    ? 'reconversion'
                    : 'transactionDetail',
              })
            )
                }, null, 8, ["transaction", "onClick"]))
              }), 128)),
              (
              _ctx.transactionBatchLoader.elements.length == 0 &&
              !_ctx.transactionBatchLoader.isNewBatchLoading.value
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.$gettext("No transaction found")), 1))
                : _createCommentVNode("", true),
              (_ctx.transactionBatchLoader.isNewBatchLoading.value)
                ? (_openBlock(), _createBlock(_component_Loading, {
                    key: 1,
                    active: _ctx.transactionBatchLoader.isNewBatchLoading.value,
                    "onUpdate:active": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.transactionBatchLoader.isNewBatchLoading.value) = $event)),
                    class: "loader-container",
                    "can-cancel": false,
                    "is-full-page": false,
                    width: 30,
                    height: 30
                  }, null, 8, ["active"]))
                : _createCommentVNode("", true),
              (
              _ctx.transactionBatchLoader.hasNoMoreElements.value &&
              _ctx.transactionBatchLoader.elements.value.length === 0
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.$gettext("No transactions found")), 1))
                : _createCommentVNode("", true)
            ])
          ], 544),
          _createElementVNode("footer", _hoisted_27, [
            (_ctx.getPlatform === 'web')
              ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                  _createElementVNode("button", {
                    class: "button custom-button-modal has-text-weight-medium",
                    title: _ctx.$gettext('Download transactions'),
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.downloadCsvFile())),
                    disabled: _ctx.isTransactionsLoading
                  }, [
                    (_ctx.isTransactionsLoading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                          _createVNode(_component_fa_icon, {
                            icon: "fa-circle-notch",
                            class: _normalizeClass([{ refreshing: _ctx.isTransactionsLoading }, "fa-lg"])
                          }, null, 8, ["class"])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_31, [
                          _createVNode(_component_fa_icon, {
                            icon: "fa-download",
                            class: "fa-lg"
                          })
                        ])),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Download")), 1)
                  ], 8, _hoisted_29)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_32, [
                  _createElementVNode("button", {
                    class: "button custom-button-modal has-text-weight-medium",
                    title: _ctx.$gettext('Share transactions'),
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.shareCsvFile())),
                    disabled: _ctx.isTransactionsLoading
                  }, [
                    (_ctx.isTransactionsLoading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                          _createVNode(_component_fa_icon, {
                            icon: "fa-circle-notch",
                            class: _normalizeClass([{ refreshing: _ctx.isTransactionsLoading }, "fa-lg"])
                          }, null, 8, ["class"])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_35, [
                          _createVNode(_component_fa_icon, {
                            icon: "fa-share",
                            class: "fa-lg"
                          })
                        ])),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Share")), 1)
                  ], 8, _hoisted_33)
                ]))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}